import styled from 'styled-components';

export const Radios = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
`;
